/**
 * Faculty Note
 */
import { z } from 'zod';
import {
  FacultyNoteId,
  FacultyId,
  UserId,
  UnixTimestamp,
} from '../types/branded';
import { NoteVisibilitySchema } from '../types/enums';
import { FacultyAssetDescriptorSchema } from './faculty-asset';

const FacultyNoteAttachmentListSchema = z.array(
  z.preprocess((value) => {
    if (typeof value === 'string') {
      return {
        resourceId: value,
        fileName: value,
      };
    }
    return value;
  }, FacultyAssetDescriptorSchema),
).default([]);

export const FacultyNoteSchema = z.object({
  id: FacultyNoteId,
  facultyId: FacultyId,
  authorId: UserId,
  authorLabel: z.string().optional(),
  visibility: NoteVisibilitySchema.default('internal'),
  body: z.string().min(1).max(5000),
  category: z.enum(['General', 'Performance', 'HR', 'Other']).default('General'),
  isImportant: z.boolean().default(false),
  attachmentName: z.string().optional(),
  attachments: FacultyNoteAttachmentListSchema,
  createdAt: UnixTimestamp,
  updatedAt: UnixTimestamp,
});
export type FacultyNote = z.infer<typeof FacultyNoteSchema>;
